import { Component, OnInit } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  ies: any;
  logo: string;

  constructor(
    private document: DocumentService
  ) { }

  ngOnInit(): void {
    // Define a IES
    if ('ies' in sessionStorage) {
      this.ies = JSON.parse(sessionStorage.ies);
    }

    // Define o favicon
    this.document.gatFavicon(this.ies.path);

    // Define logo
    if (this.ies.codigo !== 5) {
      // Logo em SVG, demais marcas
      this.logo = `assets/ies/${this.ies.path}/logo.svg`;
    } else {
      // Logo em PNG, Area 1
      this.logo = `assets/ies/${this.ies.path}/logo.png`;
    }
  }

}
